export default function FORM (){
  $(()=>{

    /****************************
     * 郵便番号検索ボタン
     */
    $('[data-plugin=ajaxzip]').on('click',()=>{
      AjaxZip3.zip2addr('zip','','addr','addr'); // eslint-disable-line no-undef
      return false;
    });
    
  })
}